// En una instalacion de negocio no hay cuentas de demostracion:
// las credenciales las define el instalador.

export default function CuentasDemo() {
  return null;
}
